export default __webpack_public_path__ + "3a3e1b49917ff1ba318ff803b057126e.png";